import { render, staticRenderFns } from "./MatrixQuestionComponent.vue?vue&type=template&id=4df9baa7&scoped=true&"
import script from "./MatrixQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./MatrixQuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./MatrixQuestionComponent.vue?vue&type=style&index=0&id=4df9baa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df9baa7",
  null
  
)

export default component.exports